import PropTypes from "prop-types";
import { useState, useEffect } from "react";

const UserAsistenciaForm = ({ user = [], asistencias, getRuta, createAsistencia }) => {
  const [formData, setFormData] = useState({
    id_usuario: String(asistencias.id_usuario || 0), // Ensure it's always a string
    fecha: asistencias.fecha || 0,
    lider_id: user.id_usuario,
    id_ruta: asistencias.id_ruta || "", // Default to empty string if undefined
  });

  const [rutas, setRutas] = useState([]); // Store routes data

  useEffect(() => {
    const fetchRutas = async () => {
      try {
        const response  = await getRuta(); // Call the API function to fetch routes
        const rutasData = response.data;
        if (Array.isArray(rutasData)) {
          setRutas(rutasData); // Update state with fetched routes
        } else {
          console.error("Error: El formato de rutas no es un array", rutasData);
        }
      } catch (error) {
        console.error("Error fetching rutas:", error);
      }
    };

    fetchRutas();
  }, [getRuta]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await createAsistencia(formData);
      alert("Asistencia registrada con éxito.");
    } catch (error) {
      console.error("Error registrando la asistencia:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>Registro de Asistencia</h3>

      <div className="input-group">
        <label className="label">Numero Halcon</label>
        <input
          type="text"
          name="id_usuario"
          value={formData.id_usuario}
          onChange={handleChange}
          className="input"
        />
      </div>
      <div className="input-group">
        <label className="label">Fecha</label>
        <input
          type="date"
          name="fecha"
          value={formData.fecha}
          onChange={handleChange}
          className="input"
        />
      </div>
      <div className="input-group">
        <label className="label">Ruta</label>
        <select
          name="id_ruta"
          value={formData.id_ruta}
          onChange={handleChange}
          className="input"
        >
          <option value="">Seleccione una ruta</option>
          {Array.isArray(rutas) &&
            rutas.map((ruta) => (
              <option key={ruta.id_ruta} value={ruta.id_ruta}>
                {ruta.descripcion}
              </option>
            ))}
        </select>
      </div>
      <p></p>
      <button type="submit" className="button">
        Registrar Asistencia
      </button>
    </form>
  );
};

UserAsistenciaForm.propTypes = {
  user: PropTypes.object.isRequired, // Expecting an object for user
  asistencias: PropTypes.array,
  createAsistencia: PropTypes.func.isRequired,
  getRuta: PropTypes.func.isRequired, // Function to fetch routes
};

export default UserAsistenciaForm;
